import React, { useEffect } from 'react';
import PageContainer from 'components/@layout/PageContainer';
import { ModuleProps } from 'types';
import toggleElementByClassName from 'utilities/toggle-element-by-classname';
import PageContentLoadingProvider, {
  usePageContentLoading
} from 'providers/PageContentLoadingProvider';

type PrintScreenContainerProps = ModuleProps & { children: React.ReactElement };

const PrintScreenPage: React.FC<PrintScreenContainerProps> = ({ children, ...props }) => {
  const [{ hasPageLoaded }] = usePageContentLoading();

  useEffect(() => {
    if (hasPageLoaded) {
      toggleElementByClassName('embeddedServiceHelpButton', true);
      window.print();
    }
  }, [hasPageLoaded]);

  return <PageContainer {...props}>{children}</PageContainer>;
};

const PrintScreenContainer: React.FC<PrintScreenContainerProps> = props => (
  <PageContentLoadingProvider>
    <PrintScreenPage {...props} />
  </PageContentLoadingProvider>
);

export default PrintScreenContainer;
